import type { AiTransformRequest, AiTransformResponse } from "../types";

export async function transformText(request: AiTransformRequest): Promise<AiTransformResponse> {
  const response = await fetch("/api/ai/text-transform", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request)
  });

  let payload: AiTransformResponse | { error: string };

  try {
    payload = (await response.json()) as AiTransformResponse | { error: string };
  } catch {
    throw new Error("AI service is unavailable.");
  }

  if (!response.ok || "error" in payload) {
    throw new Error("error" in payload ? payload.error : "AI service is unavailable.");
  }

  return payload;
}
